import {
  resolveItemCreatorUid,
  resolveItemOwnerUid,
} from "../component/resolveItemOwnerUid";

function formatUserDetailLine(value: unknown): string {
  if (value === undefined || value === null) {
    return "—";
  }
  const s = String(value).trim();
  return s || "—";
}

export function isFormSubmissionRow(doc: unknown): boolean {
  return (
    doc !== null &&
    typeof doc === "object" &&
    !Array.isArray(doc) &&
    String((doc as Record<string, unknown>)._formUid ?? "").trim() !== ""
  );
}

export function validatedUserDetailRows(doc: Record<string, unknown>): { label: string; value: string }[] {
  const creatorUid = resolveItemCreatorUid(doc);
  const ownerUid = resolveItemOwnerUid(doc);
  return [
    { label: "Submitter email", value: formatUserDetailLine(doc._submitterEmail) },
    { label: "Submitter user ID", value: formatUserDetailLine(doc._submitterUserId) },
    { label: "Creator (createdBy / submitter)", value: creatorUid ?? "—" },
    { label: "Effective owner", value: ownerUid ?? "—" },
    { label: "Delegated owner (ownedBy)", value: formatUserDetailLine(doc.ownedBy) },
    { label: "createdBy", value: formatUserDetailLine(doc.createdBy ?? doc._createdBy) },
  ];
}
